/**
 * 共通変数
 */

// WordPressで読み込まれたjQueryとVelocityを取得
const $ = window.jQuery || window.$;
const Velocity = window.Velocity;

// グローバルスコープに公開
window.$ = $;
window.Velocity = Velocity;

// デバイス判定（スマートフォンかどうか）
const isSP =
  navigator.userAgent.indexOf("iPhone") > 0 ||
  navigator.userAgent.indexOf("iPad") > 0 ||
  navigator.userAgent.indexOf("iPod") > 0 ||
  navigator.userAgent.indexOf("Android") > 0;

window.isSP = isSP;

// DOM 要素取得
const body = $("body");
const overlay = $(".overlay");
const $w = $(window);
let sitenav = $(".site-nav");
if (isSP) {
  sitenav = $(".sp-site-nav");
}

window.body = body;
window.overlay = overlay;
window.$w = $w;
window.sitenav = sitenav;

// スクロール・アニメーション関連
let popAnim = false;
const scrollNode = document.scrollingElement || document.documentElement;
let scrollTop = scrollNode.scrollTop;

window.popAnim = popAnim;
// @ts-ignore
window.scrollNode = scrollNode;
// @ts-ignore
window.scrollTop = scrollTop;

// theme-color メタタグの参照を取得
// const themeColorMeta = document.querySelector('meta[name="theme-color"]');

/**
 * theme-color を変更する関数
 * @param {string} color - 設定する色（例: "#5AA9B5" または "#fff"）
 */
function updateThemeColor(color) {
  // 無効化：theme-colorメタタグが無いため
  // if (themeColorMeta) {
  //   themeColorMeta.setAttribute('content', color);
  // }
}

/**
 * ブラウザのUIを考慮したビューポートの高さ・幅をCSSに受け渡す
 */
function setViewportVariables() {
  document.documentElement.style.setProperty('--vh', window.innerHeight + 'px');
  document.documentElement.style.setProperty('--vw', window.innerWidth + 'px');
}

/**
 * ページロード時の初期化・アニメーション
 */
function init() {
  // ビューポートサイズの初期値を設定
  document.documentElement.style.setProperty('--vh-initial', window.innerHeight + 'px');
  document.documentElement.style.setProperty('--vw-initial', window.innerWidth + 'px');

  // ビューポートサイズを設定
  setViewportVariables();

  // リサイズ時にも更新
  $w.on('resize', setViewportVariables);

  Velocity(
    body,
    {
      opacity: 1
    },
    {
      easing: "easeOutExpo",
      duration: 1000
    }
  );
}

/**
 * スクロール時に要素を固定するクラス
 * ページの固定ナビゲーションメニューの表示/非表示を制御
 */
class FixMenu {
  constructor(fixObj, nextObj) {
    this.fixObj = fixObj;  // 固定する要素
    this.previousScrollTop = 0;  // 前回のスクロール位置を保持

    // fixTop を計算する関数
    this.calculateFixTop = () => {
      // ニュースページの場合は .back の位置を基準に
      if ($(".news-head").length > 0) {
        this.fixTop = $(".news-head").height();
      } else {
        // ホームページの場合は .top-image を基準に
        if (window.innerWidth < 800) {
          this.fixTop = $(".top-image").height() + $(".lead").height();
        } else {
          this.fixTop = $(".top-image").height();
        }
      }
    };

    // 初期化時に計算
    this.calculateFixTop();

    $w.on("scroll", () => {
      const currentScrollTop = scrollNode.scrollTop;

      if (currentScrollTop >= this.fixTop && this.previousScrollTop < this.fixTop) {
        this.fix();
      }
      if (currentScrollTop <= this.fixTop && this.previousScrollTop > this.fixTop) {
        this.release();
      }
      // 前回のスクロール位置を更新
      this.previousScrollTop = currentScrollTop;
    });

    // ウィンドウリサイズ時に fixTop を再計算
    $w.on("resize", () => {
      this.calculateFixTop();
    });
  }
  init() {
    if (scrollNode.scrollTop >= this.fixTop) {
      this.fix();
    }
  }
  fix() {
    body.addClass("fix");
    updateThemeColor("#fff");
  }
  release() {
    body.removeClass("fix");
    updateThemeColor("#5AA9B5");
  }
}

/**
 * スライドショー機能を提供するクラス
 * 複数の要素を順番に表示/非表示を切り替える
 */
class SlideShow {
  constructor(options) {
    let val, val1, val2;
    this._setSi = this._setSi.bind(this);
    this._fadeOut = this._fadeOut.bind(this);
    (this.slideObj = options.slideObj),
      (this.height = options.height),
      (val = options.width),
      (this.width = val != null ? val : "100%"),
      (this.paddingBtm = options.paddingBtm),
      (this.intervalTime = options.intervalTime),
      (this.fadeDuration = options.fadeDuration),
      (val1 = options.slideRandom),
      (this.slideRandom = val1 != null ? val1 : true),
      (val2 = options.firstFadeIn),
      (this.firstFadeIn = val2 != null ? val2 : true);
    this.currentSlideNum = 0;
    this.slideObj.css({
      // 'position': 'relative',
      width: this.width,
      height: this.height
      // 'padding-bottom': this.paddingBtm
    });
    this.slides = this.slideObj.children(".slide");
    this.slides.css({
      position: "absolute",
      height: this.height,
      width: this.width,
      display: "none",
      // 'padding-bottom': this.paddingBtm,
      "background-size": "contain"
    });

    this.si = null;
    // slideそれぞれにクラスを付与
    this.slides.each(function(i) {
      return $(this).addClass(`slide${i}`);
    });

    // 最初の並び順でzIndexを振る
    const slidelength = this.slides.length;
    this.slides.each(function(i) {
      return $(this).css({
        zIndex: slidelength - i
      });
    });
  }

  start() {
    if (this.firstFadeIn) {
      this.slides.eq(this.currentSlideNum).fadeIn(this.fadeDuration);
    } else {
      this.slides.eq(this.currentSlideNum).show();
    }
    return this._setSi();
  }

  _setSi() {
    return (this.si = setInterval(() => {
      let num = parseInt(this.currentSlideNum) + parseInt(1);
      if (num >= this.slides.length) {
        num = 0;
      }
      return this._change(num);
    }, this.intervalTime));
  }
  _fadeOut(num) {
    return this.slides.eq(num).fadeOut(this.fadeDuration, function() {
      return $(this).css({
        zIndex: 1
      });
    });
  }

  _change(num) {
    this.slides
      .eq(this.currentSlideNum)
      .stop()
      .fadeIn();
    this.slides
      .eq(num)
      .stop()
      .css({
        opacity: 1
      });
    this.slides.eq(this.currentSlideNum).css({
      zIndex: this.slides.length
    });
    this.slides.eq(num).css({
      zIndex: this.slides.length - 1
    });

    this._fadeOut(this.currentSlideNum);
    this.currentSlideNum = num;
    return this.slides.eq(this.currentSlideNum).show();
  }
}

/**
 * モバイルメニューを開く
 * スマートフォン画面でナビゲーションメニューを表示し、
 * オーバーレイを適用してメニュー背景をハイライト
 */
function spOpenMenu() {
  $(".sp-site-nav").addClass("spMenuPop");
  Velocity(
    $(".nav-back"),
    { opacity: 1 },
    { easing: "easeOut", display: "block", duration: 100 }
  );
  body.addClass("poped");
  // SPメニュー開いた時は背景色を白に変更
  document.body.style.backgroundColor = "#fff";
  updateThemeColor("#fff");
}

/**
 * モバイルメニューを閉じる
 * スマートフォン画面でナビゲーションメニューを非表示にし、
 * オーバーレイを削除
 */
function spCloseMenu() {
  $(".sp-site-nav").removeClass("spMenuPop");
  Velocity(
    $(".nav-back"),
    { opacity: 0 },
    { easing: "easeOut", display: "none", duration: 100 }
  );
  body.removeClass("poped");
  // メニューを閉じた時は背景色を元に戻す
  document.body.style.backgroundColor = "#5E7682";
  // メニューを閉じた時は、スクロール位置に応じて色を戻す
  if (body.hasClass("fix")) {
    updateThemeColor("#fff");
  } else {
    updateThemeColor("#5AA9B5");
  }
}

/**
 * ハンバーガーメニューとアンカーリンク操作
 * imagesLoadedコールバック内で実行するイベントリスナー設定関数
 */
function setupCommonEventListeners() {
  // ハンバーガーメニュー（メニューボタン）をクリックして開く
  $(".nav-top").on("click", function() {
    spOpenMenu();
  });

  // メニュー閉じるボタンをクリックして閉じる
  $(".sp-close").on("click", function() {
    spCloseMenu();
  });

  // アンカーリンク（#で始まるリンク）のクリック時にスムーススクロール
  $('a[href^="#"]').on("click", function(e) {
    e.preventDefault();
    const target = $($(this).attr("href"));

    // 画面幅で判定（レスポンシブ対応）
    const isSmallScreen = window.innerWidth < 800;
    let offset = -49;
    if (!isSmallScreen) {
      offset = -65;
    }
    Velocity(target, "scroll", {
      duration: 400,
      easing: "easeOut",
      offset: offset
    });
    // スクロール後にメニューが開いていれば閉じる
    if ($(".sp-site-nav").hasClass("spMenuPop")) {
      spCloseMenu();
    }
  });
}

// クラスと関数をグローバルスコープに公開
window.FixMenu = FixMenu;
window.SlideShow = SlideShow;
window.spOpenMenu = spOpenMenu;
window.spCloseMenu = spCloseMenu;
window.init = init;
window.setupCommonEventListeners = setupCommonEventListeners;
window.updateThemeColor = updateThemeColor;
